module.exports = __webpack_public_path__ + "img/zoom.e684ac05.svg";